import React from "react";
import PageHeader from "../components/PageHeader";
import ContactCTA from "../components/ContactCTA";

const ContactPage = () => (
  <>
    <PageHeader
      title="Contact LIINEX INFORMATION SYSTEMS"
      subtitle="Book a free consultation. Tell us your business, standard of interest and target timeline   and we'll come back with a clear proposal."
      crumbs={[{ label: "Contact" }]}
    />
    <ContactCTA />
    <section className="pb-20">
      <div className="lis-container">
        <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-100">
          <iframe
            title="LIS Location"
            src="https://www.google.com/maps?q=Govind+Vihar+Ghaziabad+Uttar+Pradesh+201013&output=embed"
            className="w-full h-[380px] border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  </>
);

export default ContactPage;
